<template>
  <section class="content white large-padding">
    <form class="hide-for-print" @submit.prevent="handleSubmit" spellcheck="false">
      <TheLoader :active="loading || exporting" :update="true"/>

      <fieldset style="margin: 0;">
        <div class="grid-x grid-padding-x">
          <TheAutoCompleteInput
            v-model.trim="form.code"
            ref="auksjon_input"
            name="Auksjon"
            containerClassName="cell large-2"
            :placeholder="'Velg auksjon'"
            :label="'Tilhørende auksjon'"
            :onInputCallback="onAuksjonSearchInput"
            :onSelectCallback="onAuksjonSearchSelected"
            :disabled="false"
            :required="true"
            :debounce="750"
            :minquery="2"
          >
            <div slot="item" slot-scope="props">
              <strong>{{props.item.Auksjon}}</strong>, {{props.item.Beskrivelse}}
            </div>
          </TheAutoCompleteInput>

          <div class="cell auto">
            <DateFromTillForm
              v-model="form.date"
              :labelFrom="'Sluttdato fra'"
              :labelTill="'til'"
            />
          </div>

          <TheSelectInput
            containerClassName="cell medium-4 large-2"
            label="Velg kategori"
            name="cat"
            v-model.trim="form.category"
            :items="kategoriOptions"
          />

          <div class="cell auto">
            <label>&nbsp;</label>
            <template v-if="isValidForSubmit">
              <a v-if="!(loading || exporting)" href="javascript:;" @click="handleSubmit()" class="button primary submit tiny">Ok</a>
              <a v-else-if="loading" href="javascript:;" class="button primary submit tiny loading">Ok <span class="loader-spinner"></span></a>
              <a v-else href="javascript:;" class="button primary submit tiny" disabled>Ok</a>
            </template>
            <template v-else>
              <a href="javascript:;" class="button primary submit tiny" disabled>Ok</a>
            </template>
          </div>
        </div>
      </fieldset>
    </form>
    <table v-if="!loading" class="large fixed clickable" style="width: 100%" :style="{ opacity: loading ? 0.5 : 1 }">
      <thead>
        <tr>
          <th></th>
          <th></th>
          <th>Budverdier</th>
          <th>Minste vurderingsverdi</th>
          <th>Høyeste vurderingsverdi</th>
        </tr>
      </thead>
      <tbody v-if="sectionData.length > 0">
        <tr v-for="(object) in sectionData" v-bind:key="object.Slutt">
          <td v-html="formatWeek(object)"></td>
          <td v-html="formatDate(object)"></td>
          <td>{{ formatNumber(object.sumSalesPrice) }}</td>
          <td>{{ formatNumber(object.minValuationPrice) }}</td>
          <td>{{ formatNumber(object.maxValuationPrice) }}</td>
        </tr>
      </tbody>
      <tbody v-else-if="!loading">
        <tr><td colspan="12"><em>Fant ingen auksjoner...</em></td></tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import StatistikkService from '@/services/StatistikkService'
import AuksjonService from '@/services/AuksjonService'
import MiscService from '@/services/MiscService'
import DateFromTillForm from '@/components/Inputs/DateFromTillForm'
import TheAutoCompleteInput from '@/components/Inputs/TheAutoCompleteInput'
import moment from 'moment'

export default {
  name: 'Auksjonsstatistikk',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    DateFromTillForm,
    TheAutoCompleteInput
  },
  data () {
    return {
      loading: false,
      exporting: false,
      searched: false,
      sectionData: [],
      kategoriOptions: [],
      sums: {},
      form: {
        code: null,
        category: null,
        date: {
          from: null,
          till: null
        }
      }
    }
  },
  created () {
    MiscService.loadDropdownKategori()
      .then((data) => {
        this.kategoriOptions = [
          {key: '', val: 'Velg kategori'},
          ...data
        ]
      })
  },
  computed: {
    isValidForSubmit: function () {
      return this.form.code && this.form.date.from && this.form.date.till
    }
  },
  methods: {
    handleSubmit: function () {
      if (!this.isValidForSubmit) {
        return
      }

      this.searched = false
      this.loading = true
      StatistikkService.loadAuksjonsstatistikk(this.form)
        .then(response => {
          this.sectionData = response.data
        })
        .catch(() => {
          this.sectionData = []
        })
        .then(() => {
          this.loading = false
          this.searched = true
        })
    },
    onAuksjonSearchInput: function (query) {
      return AuksjonService.searchInSettings(query)
    },
    onAuksjonSearchSelected: function (item) {
      if (item) {
        this.form.code = item.Auksjon || null
      } else {
        this.form.code = null
      }
    },
    formatWeek: function (object) {
      let date = new Date(object.Slutt)
      return moment(date).format('dddd')
    },
    formatDate: function (object) {
      let date = new Date(object.Slutt)
      return moment(date).format('DD.MM.YYYY')
    },
    formatNumber: function (value) {
      return new Intl.NumberFormat('nor-NO', { style: 'currency', currency: 'NOK' }).format(value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Reports/Stats/Auksjonsstatistikk.vue